import React from 'react';

import RadioButtonGroup from '../../ui/components/radio-button-group';
import RadioButton from '../../ui/components/radio-button';
import withWindowResize from '../../ui/components/window-resize';
import Icon from '../../ui/components/icon';
import { withError } from '../../shared/components/error-boundary';
import SearchSort, { TrackSort }  from '../../search-filter/components/search-sort';
import SearchDrawer from '../../search-filter/components/search-drawer';
import VWAFilterCount from './vwa-filter-count';
import FilterMenu from '../../filters';

import '../css/vwa-mobile-filters.less';

class VWAMobileSort extends React.PureComponent {

    handleChange = (setSort) => {
        let { closeModal, options } = this.props;
        return (value) => {
            const { field, order } = options[value];
            closeModal();
            setSort({ field, order });
        }
    }

    render() {
        const { options } = this.props;
        return (
            <TrackSort>
                {({ trackSort }) => (
                    <SearchSort options={options} onSort={trackSort}>
                        {
                            ({ options, value, setSort }) => {
                                return (
                                    <RadioButtonGroup
                                        name={"vwamobilesort"}
                                        onChange={this.handleChange(setSort)}
                                    >
                                        {
                                            options.map((sort, index) => {
                                                return (
                                                    <RadioButton
                                                        key={sort.label}
                                                        label={sort.label}
                                                        value={index}
                                                        checked={index === Math.max(value, 0)}
                                                        data-metrics-event='e_facet'
                                                        data-metrics-event-name='sortBy'
                                                        data-metrics-sort-type={sort.label && sort.label.toLowerCase().replace(/\s/ig, '-')}
                                                    />);
                                            })
                                        }
                                    </RadioButtonGroup>);
                            }
                        }
                    </SearchSort>)}
            </TrackSort>
        );
    }
}

function VWAFilters({ sortOptions, defaultExpandedFilters }) {
    return (
        <SearchDrawer label={'SORT & FILTER'} className={"vwa-mobile-filters"}>
            {
                ({ closeDrawer }) => {
                    return (
                        <>
                            <div className={'header'}>
                                <Icon name={'x'} onClick={closeDrawer} />
                                <VWAFilterCount />
                            </div>
                            <VWAMobileSort options={sortOptions} closeModal={closeDrawer} />
                            <FilterMenu
                                useAlias={true}
                                defaultExpandedFilters={defaultExpandedFilters}
                                className='v2'
                                isV2={true} align={'right'} />
                        </>
                    );
                }
            }
        </SearchDrawer>);
}

export default withError(withWindowResize(React.memo(VWAFilters)));
